import { ClassNameConstants } from "constants/classname-constants";
import { PartRecord } from "internal";
import IndicatorIcons from "organisms/indicator-buttons/indicator-icons";
import ChangeIndicatorDiffPanel from "organisms/panels/change-indicator-diff/change-indicator-diff-panel";
import TiaBookviewHeading from "organisms/panels/tia-changes/tia-bookview-heading";
import TiaChangesPanel from "organisms/panels/tia-changes/tia-changes-panel";
import PublicationComponentActions from "organisms/publication-component-actions/publication-component-actions";
import * as React from "react";
import { PropsWithChildren, ReactNode } from "react";
import useChangeIndicatorDiffPanel from "utilities/atoms/change-indicator-diff-panel/use-change-indicator-diff-panel";
import { Breakpoints } from "utilities/enumerations/breakpoints";
import PublicationComponentType from "utilities/enumerations/publication-component-type";
import useTias from "utilities/hooks/domain/publications/use-tias";
import useBreakpoint from "utilities/hooks/use-breakpoint";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

export interface PartSeparatorWithinPanelProps {
    part: PartRecord;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------
const className = "c-part-separator";

const PartSeparatorWithinPanel: React.FunctionComponent<
    PropsWithChildren<PartSeparatorWithinPanelProps>
> = (props: PropsWithChildren<PartSeparatorWithinPanelProps>) => {
    const { part } = props;

    return (
        <div className={`${className}`}>
            <section
                className={`${className}__part-title`}
                data-test-part-id={part.id}
                id={part.externalId}>
                <div className={`${className}__part-title__part-heading`}>
                    <div className={`${className}__hr `}>
                        <span className={`${className}__hr__line`}></span>
                        <div className={`${className}__title`}>
                            {part.label + " "}
                            {part.getTitle()}
                        </div>
                        <span className={`${className}__hr__line`}></span>
                    </div>
                </div>
                {props.children}
            </section>
        </div>
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default PartSeparatorWithinPanel;

// #endregion Exports
